import React, { FC, HTMLAttributes, useMemo } from "react";
import styled from "styled-components";
import { Rating } from "components/front/mypage/layout/Rating";
import { MessageThread } from "interfaces/front/business";
import dynamic from "next/dynamic";
import { Props as RemainingTextProps } from "components/front/mypage/layout/RemainingText";
import {
  Card,
  DetailLiteral,
  DetailLiteralSub,
  ImageArea,
  ItemTextArea,
  TextBackground,
  Thumbnail,
  BadgeArea,
  BadgeText,
} from "../layout/Card";
import useShowsSupportAmount from "lib/hooks/useShowsSupportAmount";

const RemainingText = dynamic<RemainingTextProps>(() => import("components/front/mypage/layout/RemainingText"), { ssr: false });

const MessageThreadItem: FC<
  HTMLAttributes<HTMLDivElement> & {
    messageThread: MessageThread;
    isShopping?: boolean;
    onSelectItem: () => void;
  }
> = ({ onSelectItem, messageThread, isShopping, ...props }) => {
  const hasGoal = useMemo(() => messageThread.goal_amount !== null, [messageThread]);
  const showsSupportAmount = useShowsSupportAmount(messageThread.support_amount);
  return (
    <Root {...props} onClick={onSelectItem}>
      {messageThread.unread_count > 0 && (
        <BadgeArea>
          <BadgeText>{messageThread.unread_count}</BadgeText>
        </BadgeArea>
      )}
      <ImageArea>
        <Thumbnail imageUrl={messageThread.project_image_url} hasGoal={hasGoal} />
        <Rating goal={messageThread.goal_amount} support={messageThread.support_amount} />
      </ImageArea>
      <ItemTextArea>
        <TextBackground />
        <DetailLiteral>{messageThread.project_title}</DetailLiteral>
        <DetailLiteral>
          {messageThread.course_names.length > 1 ? `${messageThread.course_names.length}コースを同時購入` : messageThread.course_names[0]}
        </DetailLiteral>
        <DetailLiteralSub showsSupportAmount={showsSupportAmount}>
          {!isShopping && <span style={{ marginRight: "30px" }}>{messageThread.support_amount?.toLocaleString() ?? "?"} 円</span>}
          <RemainingText supportEndAt={messageThread.support_end_at} />
        </DetailLiteralSub>
      </ItemTextArea>
    </Root>
  );
};
export default MessageThreadItem;

const Root = styled(Card)`
  position: relative;
  margin-bottom: 10px;
`;
